import { Link } from 'react-router-dom';

export function BrandMark({ footer = false }) {
  return (
    <Link className={`brand-mark${footer ? ' brand-mark--footer' : ''}`} to="/" aria-label="Vic’s Bricks home">
      <img
        className="brand-mark__logo"
        src="/brand/vics-bricks-logo.webp"
        alt=""
        width="200"
        height="184"
        loading={footer ? 'lazy' : 'eager'}
        decoding={footer ? 'async' : 'sync'}
        fetchPriority={footer ? 'auto' : 'high'}
      />
    </Link>
  );
}
